import { SvgIcon } from "@mui/material";

export const OrgIcon = (props)=>{
    return (
        <SvgIcon {...props} viewBox="0 0 1000 1000">
          <g>
            <defs>
              <rect id="SVGID_1_" x="588" y="291" width="328" height="585" />
            </defs>
            <clipPath id="clip-path-1">
              <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
            </clipPath>
            <g style={{ clipPath: 'url(#clip-path-1)' }}>
              <g>
                <path d="M836,371v425H555V371H836 M856,291H535c-33,0-60,27-60,60v525h441V351C916,318,889,291,856,291L856,291z" />
              </g>
              <g>
                <polygon points="750,459 665,459 665,544 750,544 750,459" />
              </g>
              <g>
                <polygon points="750,625 665,625 665,710 750,710 750,625" />
              </g>
            </g>
          </g>
          <g>
            <g>
              <path d="M585,206v590H164V206H585 M605,126H144c-33,0-60,27-60,60v690h581V186C665,153,638,126,605,126L605,126z" />
            </g>
            <g>
              <polygon points="335,291 250,291 250,376 335,376 335,291" />
            </g>
            <g>
              <polygon points="500,291 415,291 415,376 500,376 500,291" />
            </g>
            <g>
              <polygon points="335,458 250,458 250,543 335,543 335,458" />
            </g>
            <g>
              <polygon points="500,458 415,458 415,543 500,543 500,458" />
            </g>
            <g>
              <polygon points="335,625 250,625 250,710 335,710 335,625" />
            </g>
            <g>
              <polygon points="500,625 415,625 415,710 500,710 500,625" />
            </g>
          </g>
        </SvgIcon>
      );

}
export const OrgIcon2 = (props)=>{
    return (
      <SvgIcon {...props} viewBox="0 0 1000 1000">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M6.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM5.5 9.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM6.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 12.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm.75-4.25a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 5.75A.75.75 0 0 1 9.75 5h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 9 5.75ZM13.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Zm-.75-2.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM13.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z" />
          <path d="M2 20V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v17c0 .173-.022.34-.063.5H20a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.2-.4l-.5-.375a.75.75 0 0 1 .9-1.2l.5.375c.504.378.8.97.8 1.6v8a2 2 0 0 1-2 2h-3.562a.767.767 0 0 1-.166-.018c-.089.012-.18.018-.272.018h-3.75a.75.75 0 0 1-.75-.75V19h-3v2.25a.75.75 0 0 1-.75.75H4a2 2 0 0 1-2-2Zm2 .5h3v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v17a.5.5 0 0 0 .5.5Z" />
        </svg>
      </SvgIcon>
    );

}
